const isGooglebotFromUserAgent = (userAgent = '') => {
  if (!userAgent || typeof userAgent !== 'string') return false;

  const isGooglebotRegEx = /(Googlebot|Storebot-Google|GoogleOther|APIs-Google|AdsBot-Google|Mediapartners-Google|FeedFetcher-Google|Google-Read-Aloud|Google-Site-Verification|Google Favicon)/g;
  return isGooglebotRegEx.test(userAgent);
};

export default isGooglebotFromUserAgent;
